import { render } from "./TheBandView.vue?vue&type=template&id=1c88ea20"
import script from "./TheBandView.vue?vue&type=script&lang=js"
export * from "./TheBandView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__